import { useEffect, useRef } from 'react';
// hooks
import useModals from '../../hooks/useModals';
import useWhatsNew from '../../hooks/useWhatsNew';
// utils
import { WHATS_NEW_MODAL } from '../../utils/const';

// ----------------------------------------------------------------------

// Opens "What's new" by itself once, the first time the user opens the portal after a release
export default function WhatsNewAutoOpen() {
  const { showModal, openModal } = useModals();
  const { latest, hasUnseen } = useWhatsNew();
  const shown = useRef(false);

  useEffect(() => {
    if (shown.current || !hasUnseen || openModal) return undefined;
    // Short delay so it does not open on top of a page that is still loading
    const timer = setTimeout(() => {
      shown.current = true;
      showModal(WHATS_NEW_MODAL, { version: latest?.version });
    }, 800);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasUnseen, openModal]);

  return null;
}
